import React, { useEffect, useState } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";

import TopBar from "../TopBar";

import WelcomeDescription from "./WelcomeDescription";
import WhatYouGet from "./WhatYouGet";
import FarmerProfit from "./FarmerProfit";
import WhatOurFarmerSays from "./WhatOurFarmerSays";
import CropClasses from "./CropClasses";
import EnrollNow from "./EnrollNow";
import UserService from "../../services/UserService";
import { useHistory } from "react-router-dom";
import firebase from "../../firebase";
import config from "../../config";
import queryStringParser from "query-string";
import StateService from "../../services/StateService";
import BottomBar from "../BottomBar";
import ErrorBoundary from "../ErrorBoundry";

const LandingPage = ({
  crops,
  changeUserLanguage,
  paymentPackage,
  userState,
  states,
  languages,
  // packages,
  // authors,
  // changeUserState,
}) => {
  const useStyles = makeStyles((theme) => ({
    main: {
      minHeight: window.innerHeight,
      fontSize: "16px",
    },
    item: {
      textAlign: "center",
      padding: "4px",
      margin: "2px 0px",
    },
    welcomeMessageContainer: {
      margin: "auto",
      paddingTop: theme.spacing(20),
      paddingBottom: theme.spacing(8),
      backgroundImage: `url(${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Flanding%2Fspotlight-mobile.webp?alt=media)`,
      backgroundSize: "cover",
      backgroundRepeat: "no - repeat",
      backgroundPosition: "center",
    },
    welcomeMessageContainerDesktop: {
      margin: "auto",
      paddingTop: theme.spacing(40),
      paddingBottom: theme.spacing(5),
      backgroundImage: `url(${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Flanding%2Fspotlight-desktop.webp?alt=media)`,
      backgroundSize: "cover",
      backgroundRepeat: "no - repeat",
      backgroundPosition: "bottom",
    },
    goldVideoContainer: {
      // marginTop: "1.5vh",
      // paddingTop: "1.5vh",
      // background: "#f1f1f1",
    },
    cropThumbnail: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
    greySection: {
      background: "#FFF8E5",
      padding: "4vh 0vh",
    },
    whiteSection: {
      background: "#fff",
      padding: "4vh 0vh 0vh 0vh",
    },
    whatYouGetSection: {
      background: "#fff",
      padding: "4vh 0vh 4vh 0vh",
    },
    whatYouGetWrapper: {
      background: "#fff",
      // marginBottom: theme.spacing(4),
    },
    whatYouGetTitleContainer: {
      // marginBottom: theme.spacing(2),
    },
    whatYouGetText: {
      // marginLeft: theme.spacing(4),
    },
    whatYouGetContainer: {
      marginTop: theme.spacing(4),
      // marginBottom: theme.spacing(4),
    },
    whatYouGetContent: {
      // marginBottom: theme.spacing(1),
    },
    benefitContainer: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(1),
    },
    join25k: {
      // textAlign: "center",
    },
    twentyFiveKCaption: {
      marginTop: theme.spacing(1),
    },
    profitTitle: {
      marginLeft: theme.spacing(-2),
    },
    profitTitleDesktop: {
      marginLeft: theme.spacing(-4),
    },
    welcomeText: {
      // marginTop: theme.spacing(4),
    },
    welcomeJoinNowButton: {
      // marginBottom: theme.spacing(4),
    },
  }));
  const classes = useStyles();
  let history = useHistory();
  let [isLoading, setIsLoading] = useState(true);

  const handleScroll = () => {
    let scrollTop =
      document.body.scrollTop || document.documentElement.scrollTop;
    let scrollHeight = document.documentElement.scrollHeight;
    let clientHeight = document.documentElement.clientHeight;
    if (scrollHeight - scrollTop === clientHeight) {
      firebase.analytics().logEvent("landing_page_scrolled_to_bottom", {
        state_name: userState ? userState.name_en.toLowerCase() : "maharashtra",
      });
    }
  };

  const saveUserAndRedirect = (isNew, mobile, userState, userSource) => {
    UserService.saveUser(
      "",
      mobile,
      userState.name_en.toLowerCase(),
      true,
      false,
      isNew,
      userSource
    );
    firebase.analytics().logEvent("signup_success", {
      mobile: mobile,
      stateName: userState.name_en.toLowerCase(),
      source: userSource,
    });
    if (!userSource) {
      history.push("/dashboard");
    } else {
      if (userSource === "APP" || userSource === "EMBED") {
        history.replace(`/dashboard?source=${userSource}`);
      } else {
        history.push(`/dashboard?source=${userSource}`);
      }
    }
  };

  useEffect(() => {
    if (states && states.length > 0) {
      let queryParamString = window.location.search;
      let parsedParams = queryStringParser.parse(queryParamString);
      console.log({ parsedParams });
      // {mobile: "9960342202", source: "APPMH", utm_source: "as_app"}
      let validMobileRegex = /^[0-9]*$/;
      let mobileFromParam = null;
      if (parsedParams.mobile && validMobileRegex.test(parsedParams.mobile)) {
        mobileFromParam = parsedParams.mobile;
      }
      let stateFromParam = null;
      if (
        parsedParams.source &&
        parsedParams.source.length === 5 &&
        parsedParams.source.includes("APP")
      ) {
        let stateCode = parsedParams.source.split("APP").pop();

        let state = StateService.getStateByCode(states, stateCode);
        if (state) {
          stateFromParam = state;
        }
      }
      let trafficSource = null;
      if (parsedParams.utm_source) {
        trafficSource = parsedParams.utm_source;
      }

      let loggedInFlag = UserService.checkUserLogin();
      if (loggedInFlag === true) {
        if (mobileFromParam && stateFromParam && trafficSource) {
          if (trafficSource === "as_app") {
            UserService.updateUserSource("APP");

            history.replace("/dashboard");
          } else if (trafficSource === "as_embedded_app") {
            UserService.updateUserSource("EMBED");

            history.replace("/dashboard");
          } else {
            UserService.updateUserSource("WEB");

            history.push("/dashboard");
          }
        } else {
          UserService.updateUserSource("WEB");

          history.push("/dashboard");
        }
      } else {
        console.log({ mobileFromParam, stateFromParam, trafficSource });
        if (mobileFromParam && stateFromParam && trafficSource) {
          let userSource = "WEB";
          if (trafficSource === "as_app") {
            userSource = "APP";
          } else if (trafficSource === "as_embedded_app") {
            userSource = "EMBED";
          }

          UserService.signup("", mobileFromParam, stateFromParam, userSource)
            .then(async (response) => {
              if (response && response.data) {
                if (response.data.result === "success") {
                  saveUserAndRedirect(
                    response.data.isNew,
                    mobileFromParam,
                    stateFromParam,
                    userSource
                  );
                } else {
                  if (response.data.data) {
                    saveUserAndRedirect(
                      response.data.data.isNew,
                      mobileFromParam,
                      stateFromParam,
                      userSource
                    );
                  } else {
                    let eventData = {
                      state_name: stateFromParam.name_en,
                      mobileFromParam,
                    };

                    if (response.data.message) {
                      eventData.reason = response.data.message;
                    }
                    firebase.analytics().logEvent("joingold_failed", eventData);
                  }
                }
              }
            })
            .catch((error) => {
              firebase.analytics().logEvent("joingold_failed", {
                state_name: stateFromParam.name_en,
                source: "APP_BANNER",
                mobileFromParam,
                reason: "SOMETHING_WENT_WRONG",
              });
            });
        } else {
          firebase.analytics().logEvent("landing_page_viewed", {
            state_name: userState
              ? userState.name_en.toLowerCase()
              : "maharashtra",
          });
        }
      }
      setIsLoading(false);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [states]);

  return (
    <div className={classes.main}>
      <ErrorBoundary page={"landing"} section={"entire-page"}>
        {isLoading === false && (
          <>
            <TopBar location={"landing"} />
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                {/* Welcome description and video */}
                <WelcomeDescription classes={classes} userState={userState} />
                {/* what you get */}
                <WhatYouGet classes={classes} />
                {/* farmer profit */}
                <FarmerProfit classes={classes} userState={userState} />
                {/* what our farmer says */}
                <WhatOurFarmerSays classes={classes} userState={userState} />
                {/* crop classes */}
                <CropClasses
                  classes={classes}
                  crops={crops}
                  userState={userState}
                />
                {/* enroll now */}
                <EnrollNow
                  classes={classes}
                  location={"landing"}
                  section={"pricing"}
                  paymentPackage={paymentPackage}
                  joinLink={"/join"}
                />

                {/* footer */}
                <BottomBar
                  languages={languages}
                  location={"landing"}
                  changeUserLanguage={changeUserLanguage}
                />
              </Grid>
            </Grid>
          </>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default LandingPage;
